export const generatePatientSubtitle = (
  age?: number,
  gender?: string,
  parenthesis?: boolean,
  dateOfBirth?: string
) => {
  const bothExist = age && gender;
  const atLeastOneExists = age || gender;
  const text = `${dateOfBirth ? `${dateOfBirth} (${age})` : ''}${bothExist ? ' / ' : ''}${
    gender || ''
  }`;

  return atLeastOneExists && parenthesis ? `(${text})` : text;
};
